import React, { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("berulia_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me").then(r => setUser(r.data)).catch(() => localStorage.removeItem("berulia_token")).finally(() => setLoading(false));
  }, []);

  // axios interceptor in lib/api.js fires this when a request returns 401
  // while a token was set. Clear user state so route guards redirect; surface
  // a toast so the customer/admin understands why they got bounced.
  useEffect(() => {
    const onExpired = () => {
      if (user) toast.error("Session expirée, reconnecte-toi.");
      setUser(null);
    };
    window.addEventListener("berulia:auth-expired", onExpired);
    return () => window.removeEventListener("berulia:auth-expired", onExpired);
  }, [user]);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("berulia_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    // Email verification flow: no token returned at this stage.
    if (r.data.token) {
      localStorage.setItem("berulia_token", r.data.token);
      setUser(r.data.user);
    }
    return r.data;
  };
  const consumeAuth = (token, nextUser) => {
    localStorage.setItem("berulia_token", token);
    setUser(nextUser);
  };
  const logout = () => { localStorage.removeItem("berulia_token"); setUser(null); };

  return <AuthCtx.Provider value={{ user, setUser, login, register, logout, consumeAuth, loading }}>{children}</AuthCtx.Provider>;
}
